import React from 'react'
import PropTypes from 'prop-types'
import { useStatusReportContext } from './statusReportContext'
import ClientStatusReportDefaultLayout from './layouts/DefaultLayout/ClientStatusReportDefaultLayout'
import ClientStatusReportBoardLayout from './layouts/BoardLayout/ClientStatusReportBoardLayout'

function ClientStatusReport (props) {
  const { variant } = useStatusReportContext()

  if (variant === 'board') {
    return <ClientStatusReportBoardLayout {...props} />
  }

  return <ClientStatusReportDefaultLayout {...props} />
}

ClientStatusReport.propTypes = {
  defaultExpanded: PropTypes.bool
}

export default ClientStatusReport
